interface GreetingProps {
  name: string;
}

function Greeting({ name }: GreetingProps) {
  return (
    <h2 className="font-medium text-2xl md:text-3xl mb-6">Hello, {name}!</h2>
  );
}
export { Greeting };
